var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5694 2.125H8.81481C8.81481 0.952927 7.82659 0 6.61111 0C5.39563 0 4.40741 0.952927 4.40741 2.125H1.65278C0.740307 2.125 0 2.83886 0 3.71875V15.4062C0 16.2862 0.740307 17 1.65278 17H11.5694C12.482 17 13.2222 16.2862 13.2222 15.4062V3.71875C13.2222 2.83886 12.482 2.125 11.5694 2.125ZM6.61111 1.32812C7.06907 1.32812 7.4375 1.6834 7.4375 2.125C7.4375 2.5666 7.06907 2.92188 6.61111 2.92188C6.15315 2.92188 5.78472 2.5666 5.78472 2.125C5.78472 1.6834 6.15315 1.32812 6.61111 1.32812ZM7.57143 9.42857H10.4286C10.744 9.42857 11 9.68457 11 10C11 10.3154 10.744 10.5714 10.4286 10.5714H7.57143V13.4286C7.57143 13.744 7.31543 14 7 14C6.68457 14 6.42857 13.744 6.42857 13.4286V10.5714H3.57143C3.256 10.5714 3 10.3154 3 10C3 9.68457 3.256 9.42857 3.57143 9.42857H6.42857V6.57143C6.42857 6.256 6.68457 6 7 6C7.31543 6 7.57143 6.256 7.57143 6.57143V9.42857Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRoster);
export default __webpack_public_path__ + "static/media/AddRoster.2149989f.svg";
export { ForwardRef as ReactComponent };